module.exports = __webpack_public_path__ + "img/program_dates.0cfde478.png";